import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

// Guards a route. Always requires login. Optionally requires either:
//   • module="domains" (action defaults to "view") — the user must have that
//     permission, otherwise they're redirected to the dashboard, or
//   • adminOnly — only role === "admin" may enter.
function ProtectedRoute({ children, module, action = "view", adminOnly = false }) {
  const { isLoggedIn, isAdmin, hasPermission } = useContext(AuthContext);

  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (module && !hasPermission(module, action)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;
